import React from 'react';
import { Card } from '../components/UI/Card';
export const NetworkingGuide = () => {
  const steps = [{
    number: '1️⃣',
    title: 'Set Your Compass – What Do You Want?',
    content: <div className="space-y-4" data-id="element-4066">
          <p data-id="element-4067">Instead of "I must network more," ask:</p>
          <ul className="space-y-2" data-id="element-4068">
            <li className="flex items-start" data-id="element-4069">
              <span className="mr-2" data-id="element-4070">🔍</span>
              <span data-id="element-4071">What excites me about connecting with others?</span>
            </li>
            <li className="flex items-start" data-id="element-4072">
              <span className="mr-2" data-id="element-4073">🎯</span>
              <span data-id="element-4074">
                Am I seeking mentorship, collaboration, opportunities, or just
                inspiration?
              </span>
            </li>
            <li className="flex items-start" data-id="element-4075">
              <span className="mr-2" data-id="element-4076">💎</span>
              <span data-id="element-4077">What unique value do I bring into a conversation?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4078">
            <span className="mr-2" data-id="element-4079">✍️</span>
            <span data-id="element-4080">
              Exercise: Write 3 things you hope to gain from networking — and 3
              things you can give.
            </span>
          </p>
        </div>
  }, {
    number: '2️⃣',
    title: 'Design Your Introduction (Your Story in 30 Seconds)',
    content: <div className="space-y-4" data-id="element-4081">
          <p data-id="element-4082">
            Networking starts with clarity. But clarity doesn't mean rigidity.
          </p>
          <ul className="space-y-2" data-id="element-4083">
            <li className="flex items-start" data-id="element-4084">
              <span className="mr-2" data-id="element-4085">👤</span>
              <span data-id="element-4086">Who am I? (roles, passions, projects)</span>
            </li>
            <li className="flex items-start" data-id="element-4087">
              <span className="mr-2" data-id="element-4088">🌱</span>
              <span data-id="element-4089">What drives me? (purpose, values, interests)</span>
            </li>
            <li className="flex items-start" data-id="element-4090">
              <span className="mr-2" data-id="element-4091">🔗</span>
              <span data-id="element-4092">Who do I want to connect with right now?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4093">
            <span className="mr-2" data-id="element-4094">🎤</span>
            <span data-id="element-4095">
              Activity: Draft 2-3 "micro-intros" you can switch between (for
              events, LinkedIn, casual chats).
            </span>
          </p>
        </div>
  }, {
    number: '3️⃣',
    title: 'Choose Your Arena – Where Will You Play?',
    content: <div className="space-y-4" data-id="element-4096">
          <p data-id="element-4097">Networking happens everywhere:</p>
          <ul className="space-y-2" data-id="element-4098">
            <li className="flex items-start" data-id="element-4099">
              <span className="mr-2" data-id="element-4100">🎙</span>
              <span data-id="element-4101">Events & salons</span>
            </li>
            <li className="flex items-start" data-id="element-4102">
              <span className="mr-2" data-id="element-4103">📩</span>
              <span data-id="element-4104">DMs & email outreach</span>
            </li>
            <li className="flex items-start" data-id="element-4105">
              <span className="mr-2" data-id="element-4106">🌍</span>
              <span data-id="element-4107">Online communities & forums</span>
            </li>
            <li className="flex items-start" data-id="element-4108">
              <span className="mr-2" data-id="element-4109">☕</span>
              <span data-id="element-4110">Coffee chats</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4111">
            <span className="mr-2" data-id="element-4112">🧭</span>
            <span data-id="element-4113">
              Prompt: Where do you already feel most comfortable starting? Where
              do you want to stretch yourself?
            </span>
          </p>
        </div>
  }, {
    number: '4️⃣',
    title: 'Practice the First Move',
    content: <div className="space-y-4" data-id="element-4114">
          <p data-id="element-4115">Instead of waiting for serendipity, design it.</p>
          <ul className="space-y-2" data-id="element-4116">
            <li data-id="element-4117">
              <strong data-id="element-4118">Warm path:</strong> Ask someone you know for an intro.
            </li>
            <li data-id="element-4119">
              <strong data-id="element-4120">Curious path:</strong> Reach out with a thoughtful
              question.
            </li>
            <li data-id="element-4121">
              <strong data-id="element-4122">Bold path:</strong> DM someone you admire with a specific
              compliment or idea.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4123">
            <span className="mr-2" data-id="element-4124">💡</span>
            <span data-id="element-4125">
              Challenge: This week, make 2 connections: one warm intro, one bold
              outreach.
            </span>
          </p>
        </div>
  }, {
    number: '5️⃣',
    title: 'Build Trust, Not Just Contacts',
    content: <div className="space-y-4" data-id="element-4126">
          <p data-id="element-4127">Think about conversations as bridges, not transactions.</p>
          <ul className="space-y-2" data-id="element-4128">
            <li className="flex items-start" data-id="element-4129">
              <span className="mr-2" data-id="element-4130">👂</span>
              <span data-id="element-4131">Listen deeply.</span>
            </li>
            <li className="flex items-start" data-id="element-4132">
              <span className="mr-2" data-id="element-4133">🎁</span>
              <span data-id="element-4134">
                Offer something of value (resource, insight, connection).
              </span>
            </li>
            <li className="flex items-start" data-id="element-4135">
              <span className="mr-2" data-id="element-4136">🔄</span>
              <span data-id="element-4137">
                Follow up quickly with gratitude + a simple next step.
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4138">
            <span className="mr-2" data-id="element-4139">✨</span>
            <span data-id="element-4140">
              Reflection: Recall the last time someone made you feel heard. How
              can you replicate that in your networking?
            </span>
          </p>
        </div>
  }, {
    number: '6️⃣',
    title: 'Keep the Web Alive',
    content: <div className="space-y-4" data-id="element-4141">
          <p data-id="element-4142">A network is like a garden — it needs tending.</p>
          <ul className="space-y-2" data-id="element-4143">
            <li className="flex items-start" data-id="element-4144">
              <span className="mr-2" data-id="element-4145">🌱</span>
              <span data-id="element-4146">Share updates about your journey.</span>
            </li>
            <li className="flex items-start" data-id="element-4147">
              <span className="mr-2" data-id="element-4148">🎉</span>
              <span data-id="element-4149">Celebrate others' wins.</span>
            </li>
            <li className="flex items-start" data-id="element-4150">
              <span className="mr-2" data-id="element-4151">🔗</span>
              <span data-id="element-4152">Connect people to each other.</span>
            </li>
            <li className="flex items-start" data-id="element-4153">
              <span className="mr-2" data-id="element-4154">📒</span>
              <span data-id="element-4155">
                Track relationships (Notion, Airtable, CRM, even your Notes
                app).
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4156">
            <span className="mr-2" data-id="element-4157">🛠</span>
            <span data-id="element-4158">
              Action: Create your personal "Connection Tracker" — 5 people to
              re-engage with this month.
            </span>
          </p>
        </div>
  }, {
    number: '7️⃣',
    title: 'Your Rules, Your Rhythm',
    content: <div className="space-y-4" data-id="element-4159">
          <p data-id="element-4160">
            Forget the idea that networking = constant hustle. It's about
            finding your rhythm:
          </p>
          <ul className="space-y-2" data-id="element-4161">
            <li data-id="element-4162">
              <strong data-id="element-4163">Monthly:</strong> New introductions.
            </li>
            <li data-id="element-4164">
              <strong data-id="element-4165">Weekly:</strong> Small touchpoints.
            </li>
            <li data-id="element-4166">
              <strong data-id="element-4167">Daily:</strong> One authentic conversation.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4168">
            <span className="mr-2" data-id="element-4169">📓</span>
            <span data-id="element-4170">
              Design Your Rhythm: What feels sustainable and energizing for you?
            </span>
          </p>
        </div>
  }];
  return <div className="pt-20" data-id="element-4171">
      <section className="py-16 bg-secondary/5" data-id="element-4172">
        <div className="container mx-auto px-4" data-id="element-4173">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4174">
            🌐 The Networking Guide: Build Connections That Matter
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4175">
            This is not a rulebook. It's a playground for you to explore how you
            connect, what feels authentic, and where you want your network to
            take you.
          </p>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto mt-4" data-id="element-4176">
            You'll find reflection prompts, mini-experiments, and action
            challenges — designed so you shape your own networking style.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4177">
        <div className="container mx-auto px-4" data-id="element-4178">
          <div className="space-y-12" data-id="element-4179">
            {steps.map((step, index) => <Card key={index} className="p-6 border-2 border-gray-200" data-id="element-4180">
                <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-4181">
                  <div className="text-3xl font-bold text-primary" data-id="element-4182">
                    {step.number}
                  </div>
                  <div className="flex-1" data-id="element-4183">
                    <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4184">
                      {step.title}
                    </h2>
                    <div className="text-secondary" data-id="element-4185">{step.content}</div>
                  </div>
                </div>
              </Card>)}
            <Card className="p-6 border-2 border-gray-200" data-id="element-4186">
              <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4187">
                ⚡ Quick Experiments (Choose Your Path)
              </h2>
              <div className="space-y-4" data-id="element-4188">
                <p className="flex items-start" data-id="element-4189">
                  <span className="mr-2 text-xl" data-id="element-4190">🎭</span>
                  <span data-id="element-4191">
                    <strong data-id="element-4192">The Actor's Game:</strong> Try introducing yourself
                    3 different ways in one week. Notice what lands.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4193">
                  <span className="mr-2 text-xl" data-id="element-4194">📩</span>
                  <span data-id="element-4195">
                    <strong data-id="element-4196">The 5-Message Sprint:</strong> Send 5 personalized
                    messages in 5 days. Track replies.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4197">
                  <span className="mr-2 text-xl" data-id="element-4198">☕</span>
                  <span data-id="element-4199">
                    <strong data-id="element-4200">The Coffee Challenge:</strong> Book 2 chats with
                    people outside your usual circle this month.
                  </span>
                </p>
              </div>
              <p className="mt-6 font-medium" data-id="element-4201">
                👉 By the end of this guide, you don't just "learn how to
                network." You invent your own networking practice — one that
                feels natural, generous, and effective.
              </p>
            </Card>
          </div>
        </div>
      </section>
    </div>;
};